import React, { useMemo, useState } from 'react'
import Button, { Link } from '../../../../components/Button'
import FormCreator from '../../../../components/FormCreator'
import Modal, { ModalFlexContainer } from '../../../../components/Modal'
import { useUser } from '../../../../data/user'
import { useTeam } from '../../data/team'
import { startCase } from 'lodash'
import styled from '@emotion/styled/macro'
import Card, { CardBody, CardTitle } from '../../../../components/Card.ui'
import MemberList from './MemberList'
import { Select } from '../../../../components/Form.ui'
import { TitleMenu } from '../../../public/Title'
import { NumberWithLabel } from '../../../../components/NumberWithLabel'
const attendanceFormFields = [
    {
        name: 'status',
        label: 'status',
        type: 'select',
        options: [
            { value: 'going' },
            { value: 'maybe' },
            { value: 'notGoing' },
        ],
    },
]

const AttendanceLink = styled(Link)`
    display: flex;
    justify-content: space-evenly;
    text-decoration: none;
    width: 100%;
`
const attendanceFormOptions = [
    { value: 'going' },
    { value: 'maybe' },
    { value: 'notGoing' },
    { value: 'notResponded' },
]
const MyAttendanceForm = ({ event, onComplete }) => {
    const [{ api, teamUser, activeTeam }] = useTeam()
    const [disabled, setDisabled] = useState(false)
    // const event = activeTeam.eventStore[_id]
    const myAttendance = useMemo(
        () => event?.attendances?.find(({ user }) => user === teamUser._id),
        [event.attendances]
    )
    return (
        <Select
            menuPlacement="top"
            options={attendanceFormOptions}
            // isSearchable={false}
            value={myAttendance?.status || 'notResponded'}
            disabled={disabled}
            onChange={(attendance) =>
                api
                    .updateMyAttendance(event._id, { status: attendance })
                    .then(() => {
                        onComplete?.()
                        setDisabled(false)
                    })
            }
        ></Select>
    )
}
const EventAttendance = ({ event, onUpdated, view }) => {
    const [showAttendanceList, setShowAttendanceList] = useState(false)
    const [{ activeTeam, api, teamUser }] = useTeam()
    const [{ activeUser }] = useUser()
    const [openAttendanceModal, setOpenAttendanceModal] = useState(false)
    const [openFullAttendanceModal, setOpenFullAttendanceModal] =
        useState(false)
    const attendanceMap = useMemo(
        () =>
            event?.attendances?.reduce(
                (acc, a) => (a.user ? { [a.user]: a, ...acc } : acc),
                {}
            ) || {},
        [event.attendances]
    )
    const attendanceMembers = activeTeam?.members?.map((member) => ({
        ...member,
        attendance: attendanceMap[member?._id],
    }))
    const { going, maybe, notGoing, notResponded } = useMemo(
        () =>
            attendanceMembers?.reduce(
                (acc, mmbr) => {
                    switch (mmbr.attendance?.status) {
                        case 'going':
                            acc.going.push(mmbr)
                            return acc
                        case 'maybe':
                            acc.maybe.push(mmbr)
                            return acc
                        case 'notGoing':
                            acc.notGoing.push(mmbr)
                            return acc
                        case undefined:
                        default:
                            acc.notResponded.push(mmbr)
                            return acc
                    }
                },
                { going: [], maybe: [], notGoing: [], notResponded: [] }
            ),
        [attendanceMembers]
    )
    const showAttendances = (type) => setShowAttendanceList.bind(null, type)

    // const notResponded=
    const myAttendance = event?.attendances?.find(
        ({ user }) => user === teamUser?._id
    )
    return (
        <>
            {view === 'button' ? (
                <AttendanceLink
                    onClick={setOpenFullAttendanceModal.bind(null, true)}
                >
                    <NumberWithLabel
                        color={
                            myAttendance?.status === 'going'
                                ? 'grays-80'
                                : 'grays-60'
                        }
                    >
                        <h2>{going?.length} </h2>
                        <small>yes</small>
                    </NumberWithLabel>
                    <NumberWithLabel
                        color={
                            myAttendance?.status === 'maybe'
                                ? 'grays-80'
                                : 'grays-60'
                        }
                        className={
                            myAttendance?.status === 'maybe'
                                ? 'myAttendance'
                                : ''
                        }
                    >
                        <h2>{maybe?.length} </h2>
                        <small>maybe</small>
                    </NumberWithLabel>
                    <NumberWithLabel
                        color={
                            myAttendance?.status === 'notGoing'
                                ? 'grays-80'
                                : 'grays-60'
                        }
                    >
                        <h2>{notGoing?.length} </h2>
                        <small>no</small>
                    </NumberWithLabel>
                    <NumberWithLabel
                        color={
                            !myAttendance ||
                            myAttendance?.status === 'notResponded'
                                ? 'grays-80'
                                : 'grays-60'
                        }
                    >
                        <h2>{notResponded?.length} </h2>
                        <small>???</small>
                    </NumberWithLabel>
                </AttendanceLink>
            ) : (
                <div>
                    <h4>Attendance</h4> <strong>me: </strong>{' '}
                    <Link onClick={setOpenAttendanceModal.bind(null, true)}>
                        {myAttendance
                            ? startCase(myAttendance?.status)
                            : 'Let your team know if you can make it'}
                    </Link>
                    <dl>
                        <dt onClick={showAttendances('going')}>
                            Going ({going?.length})
                        </dt>
                        <dd></dd>
                        <dt onClick={showAttendances('maybe')}>
                            Maybe ({maybe.length})
                        </dt>
                        <dd></dd>
                        <dt onClick={showAttendances('notGoing')}>
                            Not Going ({notGoing.length})
                        </dt>
                        <dd></dd>
                        <dt onClick={showAttendances('notResponded')}>
                            not responded ({notResponded.length})
                        </dt>
                        <dd></dd>
                    </dl>
                </div>
            )}
            {openAttendanceModal && (
                <Modal
                    isOpen={!!openAttendanceModal}
                    closeModal={setOpenAttendanceModal.bind(null, false)}
                >
                    <h2>Are you coming?</h2>
                    <p>
                        Please use the selection below to set your attendance
                        for the event.
                    </p>
                    <MyAttendanceForm
                        event={event}
                        onComplete={() => {
                            setOpenAttendanceModal(false)
                            onUpdated?.()
                        }}
                    />
                </Modal>
            )}
            {showAttendanceList && (
                <Modal
                    isOpen={!!showAttendanceList}
                    closeModal={setShowAttendanceList.bind(null, false)}
                >
                    <h3>{startCase(showAttendanceList)}</h3>
                    <MemberList
                        members={
                            { going, maybe, notGoing, notResponded }[
                                showAttendanceList
                            ]
                        }
                    ></MemberList>
                </Modal>
            )}
            {openFullAttendanceModal && (
                <Modal
                    isOpen={!!openFullAttendanceModal}
                    closeModal={setOpenFullAttendanceModal.bind(null, false)}
                    noPadding
                >
                    <FullAttendanceComponent
                        {...{ going, maybe, notGoing, notResponded }}
                        event={event}
                    ></FullAttendanceComponent>
                </Modal>
            )}
        </>
    )
}

export default EventAttendance

const ModalTitle = styled('div')`
    background-color: var(--colors-primary-accent);
    border-bottom: var(--borders-main);
    margin-bottom: 1.5rem;
`
const attendanceMap = {
    going: 'yes',
    maybe: 'maybe',
    notGoing: 'no',
    notResponded: '???',
}

const EmptyStateTranslations = {
    notResponded: 'Everyone has responded to this event already!',
    notGoing: 'No one has cancelled the event yet ',
    going: 'It seems like no one is coming as of yet ',
    maybe: 'No maybes yet',
}
function FullAttendanceComponent(props) {
    const [{ teamUser }] = useTeam()
    const keys = ['going', 'maybe', 'notGoing', 'notResponded']
    const [unlockAdmin, setUnlockAdmin] = useState()
    const [page, setPage] = useState('going')
    const isAdmin = teamUser.roles.includes('admin')

    return (
        <ModalFlexContainer>
            <ModalTitle>
                {/* <Select
                    options={keys.map((value) => ({
                        value,
                        label: `${startCase(value)} (${props[value].length})`,
                    }))}
                    value={{
                        value: page,
                        label: `${startCase(page)} (${props[page].length})`,
                    }}
                    onChange={(value) => setPage(value)}
                ></Select> */}

                <h4>{props.event.title}</h4>
                <TitleMenu>
                    {keys.map((key) => (
                        <Link
                            key={key}
                            onClick={() => setPage(key)}
                            className={key === page ? 'active' : ''}
                        >
                            {attendanceMap[key]} ({props[key].length})
                        </Link>
                    ))}
                </TitleMenu>
            </ModalTitle>
            <div style={{ padding: '1rem', height: '100%', overflow: 'auto' }}>
                {props[page].length ? (
                    <MemberList
                        members={props[page]}
                        canEdit={unlockAdmin}
                        eventId={props.event?._id}
                        attendance={page}

                        // onChange={}
                    />
                ) : (
                    <p>{EmptyStateTranslations[page]}</p>
                )}
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderTop: 'var(--borders-main)',
                    backgroundColor: 'var(--colors-grays-20)',
                    padding: '0.75rem',
                }}
            >
                <h4 style={{ width: '7rem' }}> You are: </h4>
                <MyAttendanceForm event={props.event} menuPlacement="top" />
            </div>
            {isAdmin && (
                <div
                    onClick={() => setUnlockAdmin((v) => !v)}
                    style={{
                        padding: '0.75rem',
                        backgroundColor: 'var(--colors-grays-20)',
                    }}
                >
                    <strong>
                        {!unlockAdmin
                            ? '🔒 edit attendances'
                            : '🔓 lock attendances'}
                    </strong>
                </div>
            )}
        </ModalFlexContainer>
    )
}
